import { useEffect, useLayoutEffect } from 'react'

export const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined'
        ? useLayoutEffect
        : useEffect
